module.exports = __webpack_public_path__ + "img/banner.75837b79.jpg";